import { Fragment } from 'react';
import { DateTime } from 'luxon';
import currency from 'currency.js';

const NetSheetComparisonSection = ({ netSheets, rowsToLeaveOut, dataSection, sectionName, netSheetsWithData }) => {

    const cleanUpRowName = (name) => {
        var rowName = name.charAt(0).toUpperCase() + name.slice(1).replace(/([a-z])([A-Z0-9])/g, '$1 $2');
        rowName = rowName.replace("Pct", "Percentage");
        rowName = rowName.replace("Buyers", "Buyer's");
        rowName = rowName.replace("Sellers", "Seller's");
        rowName = rowName.replace("Lenders", "Lender's");
        rowName = rowName.replace("Homeowners", "Homeowner's");
        rowName = rowName.replace("Owners", "Owner's");
        rowName = rowName.replace("Home Owner's", "Homeowner's");
        rowName = rowName.replace("Va ", "VA ");
        rowName = rowName.replace("Coverage One", "CoverageOne");
        rowName = rowName.replace("Buyer's EDoc", "eDoc");
        rowName = rowName.replace("Seller's EDoc", "eDoc");
        if (netSheetsWithData[0].netSheetFormData.propertyCounty.stateAbbr === 'WA') {
            rowName = rowName.replace("Second Half", "*Half Year Taxes");
        }
        else if (netSheetsWithData[0].netSheetFormData.propertyCounty.stateAbbr === 'ID') {
            rowName = rowName.replace("Second Half", "*2nd Half Prior Year Taxes");
        }
        else {
            rowName = rowName.replace("Second Half", "*2nd Half Taxes");
        }
        rowName = rowName.replace("Tax Proration", "*Tax Proration");
        if (netSheetsWithData[0].netSheetFormData.propertyCounty.stateAbbr === 'OR') {            
            rowName = rowName.replace("Property Tax From Seller Credit", "*Tax Proration");
        }
        rowName = rowName.replace("State Excise Fee", "State Excise Tax");
        rowName = rowName.replace("City Excise Fee", "Local Excise Tax");
        return rowName;
    }

    const cleanUpFieldValue = (value, rowName) => {
        if (["discountPointsNumber", "reserveMonthsTaxes", "reserveMonthsInsurance", "discountPoints"].includes(rowName)) return value;
        if (rowName.includes('Pct') || rowName.includes('Rate') || rowName.includes("Percentage")) return value + '%';
        if (rowName.includes('Date')) return DateTime.fromISO(value).toLocaleString();
        if (value === 'EightyTwenty') return '80/20';
        return typeof value === "number" ? currency(value, { separator: ',', symbol: '$' }).format() : value;
    }

    const leaveRowOut = (row) => {
        if (row === "propertyInsurancePerYear") return true;
        if (rowsToLeaveOut.includes(row)) return true;
        if (dataSection === "netSheetFormData" && rowsToLeaveOut.includes("common_" + row)) return true;
        if (dataSection.includes("buyer") && rowsToLeaveOut.includes("buyer_" + row)) return true;
        if (dataSection.includes("seller") && rowsToLeaveOut.includes("seller_" + row)) return true;
        return false;
    }

    return (
        <><tr>
        <td className="fw-bold border-email-bottom" colSpan={netSheets.length + 1} >
            {sectionName}
                </td>
        </tr>
            {Object.keys(netSheetsWithData[0][dataSection]).map((row, i2) => {
                if (leaveRowOut(row)) return <Fragment key={"empty" + i2}></Fragment>
                return <Fragment key={dataSection + "row" + i2}>
                    <tr>
                        <td className="fw-bold text-end">{cleanUpRowName(row)}:</td>
                        {netSheetsWithData.map((ns, i) => {
                            return <td key={dataSection + "field" + i} className="no-localization">{cleanUpFieldValue(ns[dataSection][row], row)}</td>
                        })}
                    </tr>
                    {dataSection === "buyerCommonData" && row === "principalAndInterestPerMonth" && (
                        <tr>
                            <td className="fw-bold text-end">Property Taxes Per Month:</td>
                            {netSheetsWithData.map((ns, i) => {
                                const annualTaxes = ns?.netSheetFormData?.annualTaxes || 0;
                                const monthlyTaxes = annualTaxes / 12;

                                return (
                                    <td key={"taxesMonth" + i} className="no-localization">
                                        {currency(monthlyTaxes, { separator: ',', symbol: '$' }).format()}
                                    </td>
                                );
                            })}
                        </tr>
                    )}
                </Fragment>
            })}
        </>
    );
}

export default NetSheetComparisonSection;